export default __webpack_public_path__ + "static/media/MYRIADPRO-REGULAR.6c518fcd.OTF";